<template>
  <header>
    <h2>DNA-analüüsiga määratakse tolmus elavad või surnud organismid</h2>
  </header>
  <main>
    <div>
      <span> 1 </span>
      <p>
        Kodud, mille tolmu uuritakse, peaksid olema geograafiliselt eri
        piirkondadest.
      </p>
      <img
        src="https://v.postimees.ee/graafikud/2022/putukad-dna/assets/maakera.png"
      />
    </div>

    <div>
      <span> 2 </span>
      <p>Kodus võetakse tolmuproove enam-vähem samadest paikadest.</p>
      <img
        src="https://v.postimees.ee/graafikud/2022/putukad-dna/assets/maja.png"
      />
    </div>

    <div>
      <span> 3 </span>
      <p>
        Proovivõtuks kasutatakse apteekides müüdavaid steriilseid vatitikke.
      </p>
      <img
        src="https://v.postimees.ee/graafikud/2022/putukad-dna/assets/proov.png"
      />
    </div>

    <div>
      <span> 4 </span>
      <p>
        Vatitikk koos tolmuprooviga pannakse eraldi kilekotti ja lisatakse
        kirjeldus, kust proov võetud.
      </p>
      <img
        src="https://v.postimees.ee/graafikud/2022/putukad-dna/assets/proov-kotis.png"
      />
    </div>

    <div>
      <span> 5 </span>
      <p>
        Laboris toimub tolmust leitud bioloogilise materjali genoomi analüüs.
      </p>
      <img
        src="https://v.postimees.ee/graafikud/2022/putukad-dna/assets/ekraan.png"
      />
    </div>

    <div>
      <span> 6 </span>
      <p>
        Kasutades andmebaase ja arvutianalüüsi, määratakse kindlaks organismid.
      </p>
      <img
        src="https://v.postimees.ee/graafikud/2022/putukad-dna/assets/mikro.png"
      />
    </div>
  </main>
</template>

<style>
#widget {
  --section-color: #009ee2;
  --section-secondary-color: #052862;
  --dark-color: #333;

  width: 100%;
  height: 100%;

  max-width: 720px;

  margin: auto;

  font-family: Roboto, Arial, sans-serif;
  font-size: 16px;

  word-spacing: 0 !important;
  letter-spacing: 0;
  line-height: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>

<style scoped>
header {
  text-align: center;
  margin-bottom: 5em;
}

main {
  display: flex;
  flex-direction: column;
}

main > div {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;

  gap: 10%;

  position: relative;
}

main > div + div {
  margin-top: 20%;
}

main > div:nth-child(2n) {
  flex-direction: row-reverse;
}

main > div span {
  position: absolute;
  top: 0;
  left: 0;

  width: 2em;
  height: 2em;

  font-weight: bold;

  background-color: var(--section-secondary-color);
  color: white;

  display: grid;
  place-items: center;

  border-radius: 1em;
}

main > div:nth-child(2n) span {
  left: unset;
  right: 0;
}

main > div p {
  line-height: 1.6;
  letter-spacing: 0.02em;
}

main > div img {
  max-width: 50%;
  user-select: none;
}

main > div:hover span {
  filter: brightness(1.5);
}

@media (max-width: 454px) {
  main > div p {
    line-height: 1.25;
    letter-spacing: 0.015em;
    font-size: 0.9em;
  }
  main > div span {
    top: -25%;
  }
}
</style>

<script>
export default {
  name: "Widget",
  data: () => ({
    containerElement: null,
    // isLarge: true,
  }),
  mounted() {
    this.containerElement = document.querySelector("#widget");
    // console.log("Widget mounted", this.containerElement, window);

    window.addEventListener("resize", this.onResize);
    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      const bounds = this.containerElement.getBoundingClientRect();
      // console.log("Widget bounds", bounds);
      const { width, height } = bounds;
      // console.log(width, height);

      this.isLarge = width > 600;
    },
  },
  computed: {},
};
</script>
